"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CastingFormGroupsListDataFromJSON = CastingFormGroupsListDataFromJSON;
exports.CastingFormGroupsListDataFromJSONTyped = CastingFormGroupsListDataFromJSONTyped;
exports.CastingFormGroupsListDataToJSON = CastingFormGroupsListDataToJSON;
exports.CastingFormGroupsListDataToJSONTyped = CastingFormGroupsListDataToJSONTyped;
function CastingFormGroupsListDataFromJSON(json) {
    return CastingFormGroupsListDataFromJSONTyped(json, false);
}
function CastingFormGroupsListDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': json['items'],
    };
}
function CastingFormGroupsListDataToJSON(value) {
    return CastingFormGroupsListDataToJSONTyped(value, false);
}
function CastingFormGroupsListDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': value.items,
    };
}
